import { HeroImage } from './types'

export const heroImages: HeroImage[] = [
  {
    firstColumn: 'https://static.masterclass.com/Carousel_Class_1.png', // /series/tell-a-great-story
    secondColumn: 'https://static.masterclass.com/Carousel_Subcat_3.png', // /subcategories/elevate-cooking-techniques
  },
  {
    firstColumn: 'https://static.masterclass.com/Carousel_Class_2.png', // /classes/lewis-hamilton-teaches-a-winning-mindset
    secondColumn: 'https://static.masterclass.com/Carousel_Class_7.png', // /classes/scripting-your-own-success
  },
  {
    firstColumn: 'https://static.masterclass.com/Carousel_Class_3.png', // /series/achieve-more-with-gen-ai
    secondColumn: 'https://static.masterclass.com/Carousel_Class_8.png', // /classes/think-like-a-sharp
  },
  {
    firstColumn: 'https://static.masterclass.com/Carousel_Subcat_1.png', // /subcategories/communicate-effectively-work-teams
    secondColumn: 'https://static.masterclass.com/Carousel_Class_9.png', // /classes/designing-a-home-that-tells-your-story
  },
  {
    firstColumn: 'https://static.masterclass.com/Carousel_Class_4.png', // /classes/brandon-mcmillan-teaches-dog-training
    secondColumn: 'https://static.masterclass.com/Carousel_Subcat_4.png', // /subcategories/physical-health-sleep
  },
  {
    firstColumn: 'https://static.masterclass.com/Carousel_Class_5.png', // /classes/timbaland-teaches-producing-and-beatmaking
    secondColumn: 'https://static.masterclass.com/Carousel_Class_10.png', // /classes/a-sommelier-s-snob-free-guide-to-wine
  },
  {
    firstColumn: 'https://static.masterclass.com/Carousel_Class_6.png', // /series/brain-health
    secondColumn: 'https://static.masterclass.com/Carousel_Class_11.png', // /classes/cornel-west-teaches-philosophy
  },
  {
    firstColumn: 'https://static.masterclass.com/Carousel_Subcat_2.png', // /subcategories/craft-writing-process-voice
    secondColumn: 'https://static.masterclass.com/Carousel_Class_12.png', // /classes/chris-voss-teaches-the-art-of-negotiation
  },
]

const IMAGE_WIDTH_DESKTOP = 285
const IMAGE_HEIGHT_DESKTOP = 356
const IMAGE_WIDTH_TABLET = 222
const IMAGE_HEIGHT_TABLET = 278
const IMAGE_WIDTH_MOBILE = 172
const IMAGE_HEIGHT_MOBILE = 215

export const IMAGE_RESOLUTIONS = {
  lg: {
    width: IMAGE_WIDTH_DESKTOP,
    height: IMAGE_HEIGHT_DESKTOP,
  },
  md: {
    width: IMAGE_WIDTH_TABLET,
    height: IMAGE_HEIGHT_TABLET,
  },
  sm: {
    width: IMAGE_WIDTH_MOBILE,
    height: IMAGE_HEIGHT_MOBILE,
  },
}
